import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/joy";
import { ApiZone, ClimbType } from "griptonite-api-client";

import { useVenueZonesByClimbType } from "@/hooks/routes";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { useModal } from "./modals/useModal";

export default function ManageZones({ climbType }: { climbType: ClimbType }) {
  const venueUuid = useCurrentVenueUuid();
  const { data: zones } = useVenueZonesByClimbType(venueUuid, climbType);

  const { display: displayModal } = useModal();

  return (
    <Box sx={{ padding: 2, height: "100dvh", overflow: "auto" }}>
      <Typography level="title-lg" sx={{ marginBottom: 2 }}>
        {climbType === "SPORT" ? "Sport Sectors" : "Bouldering Zones"}
      </Typography>
      <Stack gap={1} sx={{ marginBottom: 2 }}>
        {zones?.map((zone) => (
          <ZoneItem key={zone.uuid} zone={zone} />
        ))}
      </Stack>
      <Button
        startDecorator={<Add />}
        onClick={() =>
          displayModal("EDIT_ZONE", {
            zone: null,
            climbType,
          })
        }
      >
        Add {climbType === "SPORT" ? "Sector" : "Zone"}
      </Button>
    </Box>
  );
}

export const ZoneItem = ({ zone }: { zone: ApiZone }) => {
  const { display: displayModal } = useModal();
  return (
    <Stack
      sx={{
        borderRadius: 8,
        border: "1px solid",
        borderColor: "divider",
        paddingY: 1,
        paddingX: 1.5,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: (theme) => theme.vars.palette.rowHoverBackground,
        },
      }}
      direction="row"
      justifyContent="space-between"
      onClick={() =>
        displayModal("EDIT_ZONE", {
          zone,
        })
      }
    >
      <Typography level="title-md">{zone.name}</Typography>
      <Typography>
        {zone.routesCount ?? 0} route{zone.routesCount != 1 ? "s" : ""}
      </Typography>
    </Stack>
  );
};
